import { render, staticRenderFns } from "./editReport.vue?vue&type=template&id=22e54092"
import script from "./editReport.vue?vue&type=script&lang=js"
export * from "./editReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports